import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

export const smallTextStyles = {
  smallTextStylesFontOnWhite: {
    fontFamily: "'Noto Sans HK', sans-serif",
    fontSize: 12,
    fontWeight: 400,
    color: '#484848',
    lineHeight: '18px',
    margin: 0,
    padding: 0,
  },
  smallTextStylesFontOnGreen: {
    fontFamily: "'Noto Sans HK', sans-serif",
    fontSize: 12,
    fontWeight: 400,
    color: '#000',
    lineHeight: '18px',
    margin: 0,
    padding: 0,
  },
};

const useStyles = makeStyles(() => smallTextStyles);

const SmallText = (props) => {
  const { className, onGreen, ...otherProps } = props;
  const classes = useStyles();

  return (
    <Typography
      className={classNames([
        onGreen ? classes.smallTextStylesFontOnGreen : classes.smallTextStylesFontOnWhite,
        className,
      ])}
      component="p"
      {...otherProps}>
      {props.children}
    </Typography>
  );
};

SmallText.propTypes = {
  onGreen: PropTypes.bool,
};

export default SmallText;
